import { createVanIconComponent } from "./van"

const Fail = createVanIconComponent("fail")
export default Fail
